<div class="cx-consignment-tracking-dialog" [cxFocus]="focusConfig" (esc)="close('Escape clicked')">
  <div class="cx-consignment-tracking-container">
    @if (tracking$ | async; as consignmentTracking) {
      <!-- Modal Header -->
      <div class="cx-modal-header">
        <div class="cx-consignment-tracking-title modal-title">
          {{ 'orderDetails.consignmentTracking.dialog.header' | cxTranslate }}
        </div>
        <button type="button" class="close" [attr.aria-label]="'common.close' | cxTranslate"
          (click)="close('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <!-- Modal Body -->
      <!-- shipment header -->
      @if (
        consignmentTracking?.carrierDetails &&
        consignmentTracking?.trackingID) {
        <div class="cx-shipment-heading">
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <div class="cx-shipment-title">
                {{
                'orderDetails.consignmentTracking.dialog.shipped'
                | cxTranslate
                }}
              </div>
              <div class="cx-shipment-content">
                {{ shipDate | cxDate: 'medium' }}
              </div>
            </div>
            <div class="col-sm-12 col-md-6">
              <div class="cx-shipment-title">
                {{
                'orderDetails.consignmentTracking.dialog.estimate'
                | cxTranslate
                }}
              </div>
              <div class="cx-shipment-content">
                {{ consignmentTracking?.targetArrivalDate | cxDate: 'medium' }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <div class="cx-shipment-title">
                {{
                'orderDetails.consignmentTracking.dialog.carrier'
                | cxTranslate
                }}
              </div>
              <div class="cx-shipment-content">
                {{ consignmentTracking?.carrierDetails?.name }}
              </div>
            </div>
            <div class="col-sm-12 col-md-6">
              <div class="cx-shipment-title">
                {{
                'orderDetails.consignmentTracking.dialog.trackingId'
                | cxTranslate
                }}
              </div>
              <div class="cx-shipment-content">
                @if (consignmentTracking?.trackingUrl) {
                  <a target="_blank" rel="noopener noreferrer" [href]="consignmentTracking.trackingUrl">{{
                  consignmentTracking?.trackingID }}</a>
                }
                @if (!consignmentTracking?.trackingUrl) {
                  <label>
                    {{ consignmentTracking?.trackingID }}
                  </label>
                }
              </div>
            </div>
          </div>
        </div>
      } @else {
        <div class="cx-no-tracking-heading">
          <div class="cx-shipment-content">
            {{
            'orderDetails.consignmentTracking.dialog.noTracking' | cxTranslate
            }}
          </div>
        </div>
      }
      <!-- tracking events -->
      <div class="cx-tracking-events modal-body">
        @for (consignmentEvent of consignmentTracking.trackingEvents; track consignmentEvent) {
          <div class="cx-tracking-event-body">
            <div class="cx-tracking-event-content">
              {{ consignmentEvent.eventDate | cxDate: 'medium' }}
            </div>
            <div class="cx-tracking-event-title">
              {{ consignmentEvent.referenceCode }}
            </div>
            <div class="cx-tracking-event-content">
              {{ consignmentEvent.detail }}
            </div>
            <div class="cx-tracking-event-city">
              location: {{ consignmentEvent.location }}
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="cx-tracking-loading">
        <div class="header modal-header">
          <div class="title modal-title">
            {{
            'orderDetails.consignmentTracking.dialog.loadingHeader'
            | cxTranslate
            }}
          </div>
          <button type="button" class="close btn-dismiss" [attr.aria-label]="'common.close' | cxTranslate"
            (click)="close('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <!-- Modal Body -->
        <div class="body modal-body">
          <div class="row">
            <div class="col-sm-12">
              <cx-spinner></cx-spinner>
            </div>
          </div>
        </div>
      </div>
    }


  </div>
</div>